// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"125":"component---src-pages-404-js","293":"component---src-pages-index-js"}[chunkId] + "-" + {"125":"a6f24e28e1c250bee14e","293":"6dbda69a7111fcd9e752"}[chunkId] + ".js";
};